import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Form, Button, Card, Container, Row, Col, FloatingLabel, Spinner } from "react-bootstrap";
import "./Login.css";
import { apiUrl } from "../commons/inFormTypes";
import { useNavigate, NavLink, useSearchParams, Navigate } from "react-router-dom";
import Footer from "../components/Footer";
import HeaderLogin from "../components/HeaderLogin";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Loaders from "../components/Loaders";
import Logo4x from '../assets/img/Logo4x.png';
import { Avatar } from "antd";
import ReactCodeInput from "react-code-input";
import LoaderBtn from "../components/LoaderBtn";
import BigLoader from "../components/BigLoader";
import Header from "../components/Header";
import useViewport from "../custom-hooks/useViewport ";
import MunicipalityDataContext from "../helpers/MunicipalityDataContext";


const props = {
  className: ReactCodeInput,
  inputStyle: {
    fontFamily: 'Yekan Bakh Fa 05 Medium',
    // fontFamily: 'monospace',
    borderRadius: '6px',
    border: '1px solid lightgrey',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px 0px',
    margin: '3px',
    paddingLeft: '8px',
    width: '50px',
    height: '50px',
    fontSize: '32px',
    boxSizing: 'border-box',
    color: 'black',
    backgroundColor: 'white',
  }
}

const Login = () => {
  const [snip, setSnip] = useState(false);
  const [load, setLoad] = useState(false);
  const [code, setCode] = useState("");
  const [codeMeli, setCodeMeli] = useState("");
  const [formIsValid, setFormIsValid] = useState("2");
  const [mobile, setMobile] = useState("");
  const [user, setUser] = useState("");
  const [error, setError] = useState("");
  const [errorRegister, setErrorRegister] = useState("");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const promptId1 = searchParams.get('code');
  const promptId2 = searchParams.get('state');
  const axios = require("axios");
  const { width } = useViewport();
  const municipalitiyData = useContext(MunicipalityDataContext);


  // for sso(پنل خدمات واحد کشور)
  // useEffect(() => {
  //   if (promptId1 !== null && promptId2 !== null) {
  //     setLoad(true)
  //     axios.get(`https://api.myamol.ir?code=${promptId1}&state=${promptId2}`)
  //       .then((res) => {
  //         setLoad(false)
  //         console.log("request _____________", res,promptId1,promptId2)
  //         if (res.data.result === "true") {
  //           console.log(res.data.data)
  //           localStorage.setItem("user_codemeli", res.data.data.CodeMelli);
  //           localStorage.setItem("user_mobile", res.data.data.Mobile);
  //           localStorage.setItem("user_namefamily", res.data.data.Firstname);
  //           localStorage.setItem("UserId", res.data.data.Id);
  //           localStorage.setItem("user_profile", res.data.data.Profile);
  //           navigate("/");
  //         } else {
  //           toast.error(res.data.message, {
  //             position: toast.POSITION.TOP_CENTER,
  //             autoClose: 3000,
  //           });
  //         }
  //       });
  //   }
  // }
  //   , [])

  const inputHandle = code1 => {
    setCode(code1)
    if (code1.toString().length == 5) {
      submitHandler(code1)
    }
  };

  const loginHandler = (e) => {
    e.preventDefault();
    if (mobile.length < 11 || mobile === "" || !mobile.startsWith("09")) {
      toast.error("لطفا اطلاعات درست را وارد کنید", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return false;
    } else {
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "Login", {
          mobile: mobile,
        })
        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            setFormIsValid("3");
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  };

  const submitHandler = (code1) => {
    // e.preventDefault();
    if (code1.length > 5 || code1 === "" || code1.length < 5) {
      toast.error("لطفا کد صحیح را وارد کنید", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return false;
    } else {
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "CheckCode", {
          Code: code1,
          Mobile: mobile,
        })
        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            localStorage.setItem("user_codemeli", res.data.data.CodeMelli);
            localStorage.setItem("user_mobile", res.data.data.Mobile);
            localStorage.setItem("user_namefamily", res.data.data.Firstname);
            localStorage.setItem("UserId", res.data.data.Id);
            localStorage.setItem("user_profile", res.data.data.Profile);
            navigate("/");
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  };

  const registHandler = (e) => {
    e.preventDefault();
    setFormIsValid("1");
  };

  const backHandler = (e) => {
    e.preventDefault();
    setFormIsValid("2");
  };

  const codeHandler = (e) => {
    e.preventDefault();
    if (
      mobile.length < 11 ||
      mobile === "" ||
      !mobile.startsWith("09") ||
      codeMeli === " " ||
      codeMeli.length < 10 ||
      codeMeli.length > 10 ||
      user === " "
    ) {
      toast.error("لطفا اطلاعات درست را وارد کنید", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return false;
    } else {

      setSnip(true);
      axios
        .post(apiUrl + "Register", {
          Codemelli: codeMeli,
          FirstName: user,
          mobile: mobile,
        })
        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            setFormIsValid("3");
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  };


  //enter for input insted of click button submitHandler function
  const keyPress = (e, val) => {
    if (e.keyCode === 13) {
      switch (val) {
        case 0:
          codeHandler(e)
          break;

        case 1:
          loginHandler(e);
          break;

        case 2:
          submitHandler(e);
          break;

        default:
          break;
      }
    }
  }

  //Focus on the Next Field
  const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);

      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };



  const testHandler = () => {
    switch (municipalitiyData?.name) {
      case 'آمل':
        window.location.replace("https://api.myamol.ir/api/WebApi/LoginToGOV")
        break;
      case 'رویان':
        break;
      case 'محمودآباد':
        break;
      default:
        break;
    }
    
  }

  return (
    <div>
      <Header />
      <div className="rgc-style loginStyle">
        <section className={load === true ? "opacity-50" : "opacity-100"}>
          <Container className="">
            <Row className="d-flex justify-content-center align-items-center">

              <Col xs={12} md={5} lg={6} xl={5}>
                <Card className="rgc-login-card shadow-2-strong">
                  <Card.Body className="text-center">
                    <div className="mb-3">
                      <Avatar
                        className="fa fa-user-circle rgc-avatar-log"
                        size="large"
                        src=""
                      />
                    </div>

                    <div className={formIsValid === "1" ? "d-block" : "d-none"}>
                      <Form>
                        <div className="form-outline rgc-input-icons">
                          <i className='fas fa-user-circle'></i>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="نام و نام خانوادگی"
                          >
                            <Form.Control
                              autoComplete="off"
                              className="rgc-input-floating"
                              type="text"
                              placeholder="نام و نام خانوادگی"
                              aria-describedby="userHelp"
                              value={user}
                              onChange={(event) => setUser(event.target.value)}
                              onKeyDown={handleEnter}
                            />
                          </FloatingLabel>

                          <small id="userHelp" className="text-danger form-text">
                            {errorRegister}
                          </small>
                          <br />
                        </div>

                        <div className="form-outline rgc-input-icons">
                          <i className="fa fa-id-card" aria-hidden="true"></i>
                          <FloatingLabel controlId="floatingInput" label="کد ملی">
                            <Form.Control
                              autoComplete="off"
                              className="rgc-input-floating"
                              type={width > 860 ? "text" : "number"}
                              placeholder="کد ملی"
                              aria-describedby="codeMeliHelp"
                              value={codeMeli}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onChange={(event) =>
                                setCodeMeli(event.target.value)
                              }
                              onKeyDown={handleEnter}
                            />
                          </FloatingLabel>
                          <small
                            id="codeMeliHelp"
                            className="text-danger form-text"
                          >
                            {errorRegister}
                          </small>
                          <br />
                        </div>

                        <div className="form-outline mb-3 rgc-input-icons">
                          <i className="fas fa-mobile-alt" aria-hidden="true"></i>
                          <FloatingLabel
                            controlId="floatingInput"
                            label="شماره همراه"
                          >
                            <Form.Control
                              autoComplete="off"
                              className="rgc-input-floating"
                              type={width > 820 ? "text" : "number"}
                              placeholder="شماره همراه"
                              aria-describedby="mobileHelp"
                              value={mobile}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onChange={(event) =>
                                setMobile(event.target.value)
                              }
                              onKeyDown={(event) => keyPress(event, 0)}
                            />
                          </FloatingLabel>
                        </div>
                      </Form>

                      <Button
                        type="submit"
                        className="btn-fill my-2 rgc-btn-login"
                        onClick={codeHandler}
                        variant="btn btn-primary"
                      >
                        <LoaderBtn loads={snip} />
                        <span>دریافت کد تایید</span>
                      </Button>

                      <Button
                        type="submit"
                        className="btn-fill m-1 rgc-btn-login  rgc-btn-color"
                        onClick={backHandler}
                        variant="btn btn-primary"
                      >

                        <span>بازگشت</span>
                      </Button>
                    </div>

                    <div className={formIsValid === "2" ? "d-block" : "d-none"}>
                      <div className="form-outline rgc-input-icons">
                        <i className="fas fa-mobile-alt" aria-hidden="true"></i>
                        <FloatingLabel
                          controlId="floatingInput"
                          label="شماره همراه"
                        >
                          <Form.Control
                            autoComplete="off"
                            className="rgc-input-floating"
                            type={width > 820 ? "text" : "number"}
                            placeholder="شماره همراه"
                            aria-describedby="mobileHelp"
                            value={mobile}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onChange={(event) =>
                              setMobile(event.target.value)
                            }
                            onKeyDown={(event) => keyPress(event, 1)}
                          />
                        </FloatingLabel>
                        <small
                          id="mobileHelp"
                          className="text-danger form-text"
                        >
                          {error}
                        </small>
                        <br />
                      </div>

                      <Row className="justify-content-center">
                        <Col xs={12}>
                          <Button
                            type="submit"
                            className="btn-fill rgc-btn-login  rgc-btn-color"
                            onClick={loginHandler}
                          >
                            <LoaderBtn loads={snip} />
                            <span> درخواست رمز یکبارمصرف</span>
                          </Button>

                          <Button
                            type="submit"
                            className="btn-fill my-2 rgc-btn-login"
                            onClick={registHandler}
                            variant="btn btn-primary"
                          >
                            {/* <LoaderBtn loads={snip1} />     */}
                            <span>ثبت نام</span>
                          </Button>

                          <div className="d-block d-md-none">
                            <Button
                              type="submit"
                              className="btn-fill my-2 rgc-btn-login  rgc-btn-NavyBlue"
                              onClick={testHandler}
                              variant="btn"
                            >
                              <span>ورود از پنجره واحد خدمات وزارت کشور</span>
                            </Button>
                          </div>

                        </Col>
                      </Row>
                    </div>

                    <div className={formIsValid === "3" ? "d-block" : "d-none"}>
                      <span>لطفا کد پنج رقمی را وارد نمایید</span>
                      <div className="form-outline rgc-input-icons">
                        <ReactCodeInput
                          className="pinCodeClass"
                          {...props}
                          id="pinCode"
                          type={width > 820 ? "text" : "number"}
                          fields={5}
                          filterChars='-'
                          value={code}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={inputHandle}
                          // onKeyDown={code.length === 5 ? (event) => keyPress(event, 2) : ""}
                          autoFocus={true}
                        />
                        <small id="codeHelp" className="text-danger form-text">
                          {error}
                        </small>
                        <br />
                      </div>

                      <Row className="justify-content-center mt-1">
                        <Col xs={12}>
                          <Button
                            type="submit"
                            className="btn-fill my-2 rgc-btn-login "
                            onClick={submitHandler}
                            variant="btn btn-primary"
                          >
                            <LoaderBtn loads={snip} />
                            <span>ورود</span>
                          </Button>


                          <Button
                            type="submit"
                            className="btn-fill m-1 rgc-btn-login  rgc-btn-color"
                            onClick={backHandler}
                          >
                            <i className='fas fa-share rgc-back-icon'></i>
                            <span>تغییر شماره همراه</span>
                          </Button>
                        </Col>
                      </Row>
                    </div>

                    <div className="rgc-social d-flex flex-row align-items-center justify-content-center">
                      <a href="">
                        <i
                          className="fab fa-instagram"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a href="">
                        <i className="fa fa-globe" aria-hidden="true"></i>
                      </a>
                      <a href="">
                        <i
                          className="fas fa-book-reader"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <hr className="my-4" />
                    </div>
                    <hr className="my-2" />

                    <NavLink to="/" aria-current="page" className="back-page">
                      {" "}<i className="fas fa-share rgc-back-icon"></i>
                      بازگشت به صفحه اصلی
                    </NavLink>

                    <NavLink to="" aria-current="page">
                      {" "}
                      راهنمای اپلیکیشن
                    </NavLink>
                  </Card.Body>
                </Card>
              </Col>

              <Col xs={12} md={5} lg={6} xl={5} className="d-none d-md-block">

                <Card className="rgc-login-card shadow-2-strong">
                  <Card.Body className="rgc-login-gov text-end">
                    <div className="text-center my-2">
                      <h5>راهنما</h5>
                      <div className="circle-icon">
                        <i className="fa fa-question d-block"></i>
                      </div>
                    </div>
                    <p>
                      درصورتی که تاکنون در سامانه شهر من ثبت نام
                      نکرده اید، میتوانید از طریق روش دولت من اقدام نمایید.
                    </p>

                    <Button
                      type="submit"
                      className="btn-fill my-2 rgc-btn-login  rgc-btn-NavyBlue"
                      onClick={testHandler}
                      variant="btn"
                    >
                      <span>ورود از پنجره واحد خدمات وزارت کشور</span>
                    </Button>
                    <p>
                      دولت من ، پنجره ملی خدمات دولت هوشمند از طریق
                      رمز یکبار مصرف می باشدکه شما می توانیدباوارد کردن کد ملی و
                      شماره تلفن همراه احراز هویت شوید و به خدمات شهرداری هم دسترسی داشته باشید.
                    </p>
                    <div className="text-center">
                      <span className="text-danger">توجه نمائید که مالکیت شماره تلفن همراه می بایست متعلق به شخص حقیقی با کد ملی وارد شده باشد</span>
                    </div>
                  </Card.Body>
                </Card>

              </Col>
            </Row>
          </Container>
        </section>
        <BigLoader loading={load} />
      </div>
      <div className={load === true ? "opacity-25" : "opacity-100"}>
        <Footer />
      </div>

      <div className="rgc-toast">
        <ToastContainer autoClose={3000} />
      </div>
    </div>
  )
}
export default Login;
